import { SessionModeEnum } from '@/enums/SessionModeEnum';

export default {
    title: '수업',
    buttons: {
        start: '수업 시작',
        selfStart: '자습 시작',
        end: ({ values }: { values: { mode: SessionModeEnum } }) => {
            const { mode } = values;
            if (mode === SessionModeEnum.SELF) return '자습 종료';
            if (mode === SessionModeEnum.TASK) return '과제 마감';
            return '수업 종료';
        },
        exit: '나가기',
        review: '살펴보기',
        pause: '일시정지',
        resume: '재개',
        selfModeDoneConfirm: ({ values }: { values: { mode: SessionModeEnum } }) => {
            if (values.mode === SessionModeEnum.TASK) {
                return '과제를 마감할까요?<br />마감하면 학생은 더이상 과제를 완료할 수 없어요.';
            }
            return '자습을 종료할까요?<br />아직 완료하지 않은 학생이 있다면, 지금까지 학습한 내역이 기록됩니다.';
        },
        selfDoneConfirm:
            '아직 자습이 진행중이에요. 자습을 이대로 종료할까요?<br />자습을 종료해도 지금까지 학습한 내역은 기록돼요.',
        selfDoneConfirmMessage: '자습 모드를 완료했습니다!',
        taskDoneConfirmMessage: '과제를 완료 했습니다!',
        goStudentPage: '대기실 가기',
        goTaskResult: '결과 보기',
    },
    modal: {
        title: {
            ongoing: '활동 진행중',
            completed: '{mode} 종료',
        },
        message: {
            ongoing: '진행중인 활동이 있어요.\n활동 종료 후 수업을 종료해주세요.',
            completed: '{mode}을 종료할까요?',
        },
    },

    // 수업(LECTURE) 종료 시 노출되는 피드백 설문 모달
    endFeedback: {
        survey: {
            title: '오늘 수업, 어떠셨나요?',
            description: '이번 수업에서 사용한 학습 콘텐츠에 대한 느낌을 알려주세요.',
            good: '좋았어요',
            normal: '보통이에요',
            bad: '아쉬워요',
            skip: '건너뛰고 종료',
        },
        regret: {
            title: '이번 수업이 아쉬우셨군요. 어떤 문제가 있었나요?',
            description: '피드백을 진행한 활동마다 남기실 수 있어요.\n남겨주신 내용은 빠르게 확인 후 개선하겠습니다.',
            confirm: '확인',
        },
    },
    status: {
        ongoing: '진행 중',
        completed: '완료',
        paused: '일시정지',
        preparing: '준비 중',
        waiting: '대기 중',
    },

    timer: {
        format: '{minutes}:{seconds}',
        started: '{time}에 시작됨',
        duration: '{duration}분 진행',
    },

    students: {
        online: '온라인',
        offline: '오프라인',
        total: '전체',
        count: '{count}명',
        countFormat: '{online}/{total}',
        selectAll: '전체 선택',
        selected: '선택됨',
        unselected: '선택 해제',
        notSubmitted: '미제출 학생',
    },

    screen: {
        toggle: '칠판 화면',
        on: 'ON',
        off: 'OFF',
        options: {
            none: '사용 안함',
            basic: '기본 화면',
            waitingRoom: '대기실',
            activity: '활동 화면',
            sessionResult: '수업 결과 화면',
            moduleResult: '활동 결과 화면',
        },
    },

    focus: {
        toggle: '집중 모드',
        on: '집중 모드 켜짐',
        off: '집중 모드 꺼짐',
    },

    star: {
        title: '칭찬별',
        give: '칭찬별 주기',
        comment: '칭찬 메시지',
        comments: {
            great: '잘했어요!',
            excellent: '훌륭해요!',
            good: '좋아요!',
            perfect: '완벽해요!',
            amazing: '대단해요!',
        },
    },

    module: {
        start: '활동 시작',
        end: '활동 종료',
        setting: '활동 설정',
        preview: '미리보기',
        result: '결과 보기',
        inProgress: '활동 진행 중',
        completed: '활동 완료',
        fold: '글감 접기',
        subject: '글감',
    },

    navigation: {
        home: '홈으로',
        waitingRoom: '대기실로',
        result: '결과 보기',
        next: '다음 활동',
        previous: '이전 활동',
    },
};
